const weBelieveTexts = {
	text:
		'We believe privacy is a fundamental human right.\nWith our products, stay protected everywhere and anytime.',
};

export default weBelieveTexts;
